enum actionTypes {
  CREATE_ORDER = 'CREATE_ORDER',
  GET_ORDER_DETAILS = 'GET_ORDER_DETAILS',
  GET_PAYMENT_METHODS = 'GET_PAYMENT_METHODS',
}

export default actionTypes;
